export default function VisitHeader() {
    return (
        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.27783 0.444336C3.23712 0.444336 0.777832 2.73967 0.777832 5.57767C0.777832 9.42767 6.27783 15.111 6.27783 15.111C6.27783 15.111 11.7778 9.42767 11.7778 5.57767C11.7778 2.73967 9.31855 0.444336 6.27783 0.444336ZM6.27783 7.411C5.19355 7.411 4.31355 6.58967 4.31355 5.57767C4.31355 4.56567 5.19355 3.74434 6.27783 3.74434C7.36212 3.74434 8.24212 4.56567 8.24212 5.57767C8.24212 6.58967 7.36212 7.411 6.27783 7.411Z" fill="#43656E"/>
</svg>


    )
}